import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  linkStyle: {
    color: theme.palette.text.secondary,
    '&:hover': { cursor: 'pointer', color: theme.palette.primary.main },
  },
  carrierLink: {
    paddingLeft: '5px',
  },
}));
